<template>
    <div class="couponReceive_item">
        <img class="coupon-card__background" :src="$img(couponImageBgObj[info.type])" alt="" />
        <img class="coupon-card__state" :src="$img(couponImageStateObj[info.status])" alt="" />
        <div class="coupon-card" :class="couponTextClor_obj[info.type]">
            <div class="coupon-card__main">
                <div class="coupon-card__amount" :class="couponBorderClor_obj[info.type]">
                    <span v-if="activeName == 'first'" class="coupon-card__scope">{{ info.goods_type == 1 ? '全场商品' : '指定商品' }}</span>
                    <template v-if="info.type === 'reward' || info.type === 'ladder_reward' || info.type === 'no_threshold'">
                        <div class="reward">
                            <span>￥</span>
                            <span>{{ info.money }}</span>
                        </div>
                    </template>
                    <template v-if="info.type === 'discount'">
                        <div class="discount">
                            <span>{{ info.discount }}</span>
                            <span>折</span>
                        </div>
                    </template>
                </div>
                <div class="coupon-card__details">
                    <span v-if="info.coupon_name" class="coupon-name" :title="info.coupon_name">{{ info.coupon_name }}</span>
                    <span class="coupon-card__type">{{ couponText_obj[info.type] }}</span>
                    <div class="coupon-card__divider" :class="couponBorderClor_obj_solid[info.type]"></div>
                    <template v-if="info.at_least!=='0.00'">
                        <span class="coupon-card__threshold">满{{ info.at_least }}可用</span>
                    </template>
                    <template v-else>
                        <span class="coupon-card__threshold">无门槛优惠</span>
                    </template>
                </div>
                <div class="coupon-card__action">
                    <button
                        type="button"
                        class="coupon-card__action-button"
                        :class="couponBgClor_obj[info.type]"
                        :disabled="info.useState === 3"
                        :aria-label="info.useState === 0 ? '领取优惠券' : info.useState === 3 ? '优惠券已过期' : '使用优惠券'"
                        @click="couponTap"
                    >
                        <template v-if="info.useState === 0">
                            <span>领</span>
                            <span>取</span>
                        </template>
                        <template v-else-if="info.useState === 3">
                            <span>已</span>
                            <span>过</span>
                            <span>期</span>
                        </template>
                        <template v-else>
                            <span>去</span>
                            <span>使</span>
                            <span>用</span>
                        </template>
                    </button>
                </div>
            </div>
            <div class="coupon-card__validity">
                <span v-if="info.validity_type">领取之日起{{ info.fixed_term }}日内有效</span>
                <span v-else>有效期：{{ $timeStampTurnTime(info.end_time) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: 'couponReceive',
		props: {
			info: {
				type: Object,
                required: true
			},
            activeName: {
                type: String,
                required: true
            },
            index:{
                type: Number,
                required: true
            }
		},
        data() {
            return {
                couponTextClor_obj: {
                    reward:'couponTextClor_reward',
                    discount:'couponTextClor_discount',
                    no_threshold:'couponTextClor_no_threshold',
                    ladder_reward:'couponTextClor_ladder_reward'
                },
                couponBorderClor_obj: {
                    reward:'couponBorderClor_reward_dashed',
                    discount:'couponBorderClor_discount_dashed',
                    no_threshold:'couponBorderClor_no_threshold_dashed',
                    ladder_reward:'couponBorderClor_ladder_reward_dashed'
                },
                couponBorderClor_obj_solid: {
                    reward:'couponBorderClor_reward_solid',
                    discount:'couponBorderClor_discount_solid',
                    no_threshold:'couponBorderClor_no_threshold_solid',
                    ladder_reward:'couponBorderClor_ladder_reward_solid'
                },
                couponBgClor_obj: {
                    reward:'couponBgClor_reward',
                    discount:'couponBgClor_discount',
                    no_threshold:'couponBgClor_no_threshold',
                    ladder_reward:'couponBgClor_ladder_reward'
                },
                couponText_obj: {
                    reward:'一次性满减券',
                    discount:'折扣券',
                    no_threshold:'无门槛券',
                    ladder_reward:'阶梯性满减券'
                },
                couponImageBgObj: {
                    reward:'/upload/uniapp/coupon/coupon_bg2.png', // 一次性满减 
                    discount:'/upload/uniapp/coupon/coupon_bg3.png',// 折扣券
                    no_threshold:'/upload/uniapp/coupon/coupon_bg4.png',// 无门槛
                    ladder_reward:'/upload/uniapp/coupon/coupon_bg1.png',// 阶梯性满减
                    expired:'/upload/uniapp/coupon/coupon_bg5.png'// 已过期背景
                },
                couponImageStateObj: {
                    // 未使用 已使用 已过期
                    1:'/upload/uniapp/coupon/coupon_state1.png',
                    2:'/upload/uniapp/coupon/coupon_state2.png',
                    3:'/upload/uniapp/coupon/coupon_state3.png'
                }
            }
        },
		methods: {
            couponTap(){
                this.$emit('couponTap',this.info,this.index);
            }
		}
	};
</script>
<style lang="scss" scoped>
.couponReceive_item {
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    .coupon-card__background,
    .coupon-card__state {
        position: absolute;
    }

    .coupon-card__background {
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }

    .coupon-card__state {
        left: -11px;
        top: -9px;
        width: 50px;
        z-index: 2;
    }

    // 声明颜色变量
    $couponClor_reward: #FB2B5A;
    $couponClor_discount: #D86262;
    $couponClor_no_threshold: #C50808;
    $couponClor_ladder_reward: #F7640A;

    .couponTextClor_reward {
        color: $couponClor_reward;
    }

    .couponTextClor_discount {
        color: $couponClor_discount;
    }

    .couponTextClor_no_threshold {
        color: $couponClor_no_threshold;
    }

    .couponTextClor_ladder_reward {
        color: $couponClor_ladder_reward;
    }

    .couponBorderClor_reward_dashed {
        border-right: 1px dashed $couponClor_reward;
    }

    .couponBorderClor_discount_dashed {
        border-right: 1px dashed $couponClor_discount;
    }

    .couponBorderClor_no_threshold_dashed {
        border-right: 1px dashed $couponClor_no_threshold;
    }

    .couponBorderClor_ladder_reward_dashed {
        border-right: 1px dashed $couponClor_ladder_reward;
    }

    .couponBorderClor_reward_solid {
        border-bottom: 1px solid $couponClor_reward;
    }

    .couponBorderClor_discount_solid {
        border-bottom: 1px solid $couponClor_discount;
    }

    .couponBorderClor_no_threshold_solid {
        border-bottom: 1px solid $couponClor_no_threshold;
    }

    .couponBorderClor_ladder_reward_solid {
        border-bottom: 1px solid $couponClor_ladder_reward;
    }

    .couponBgClor_reward {
        background-color: $couponClor_reward;
    }

    .couponBgClor_discount {
        background-color: $couponClor_discount;
    }

    .couponBgClor_no_threshold {
        background-color: $couponClor_no_threshold;
    }

    .couponBgClor_ladder_reward {
        background-color: $couponClor_ladder_reward;
    }

    .coupon-card {
        position: relative;
        z-index: 3;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 10px 12px 6px;
        box-sizing: border-box;
    }

    .coupon-card__main {
        display: flex;
        flex: 1;
        min-height: 0;
        align-items: center;
        width: 100%;
    }

    .coupon-card__amount {
        display: flex;
        flex: 0 0 40%;
        min-width: 0;
        height: 64px;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        box-sizing: border-box;
        padding: 0 12px 0 8px;

        .coupon-card__scope {
            overflow: hidden;
            max-width: 100%;
            font-size: 14px;
            line-height: 18px;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .reward {
            display: flex;
            align-items: flex-start;

            >span:nth-child(1) {
                font-weight: 700;
                font-size: 18px;
                line-height: 25px;
            }

            >span:nth-child(2) {
                font-weight: 700;
                font-size: 24px;
                font-variant-numeric: tabular-nums;
                line-height: 32px;
            }
        }

        .discount {
            display: flex;
            align-items: center;

            >span {
                font-weight: 700;
                font-size: 24px;
                font-variant-numeric: tabular-nums;
                line-height: 32px;
            }
        }
    }

    .coupon-card__details {
        display: flex;
        flex: 0 0 45%;
        min-width: 0;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 0 14px;
        box-sizing: border-box;
        text-align: center;

        .coupon-name {
            display: block;
            width: 100%;
            overflow: hidden;
            margin-bottom: 1px;
            font-size: 14px;
            font-weight: 700;
            line-height: 20px;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .coupon-card__type,
        .coupon-card__threshold {
            display: block;
            width: 100%;
            overflow: hidden;
            font-size: 13px;
            line-height: 18px;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .coupon-card__divider {
            width: 100%;
            margin: 1px 0;
        }
    }

    .coupon-card__action {
        display: flex;
        flex: 0 0 15%;
        min-width: 0;
        height: 100%;
        align-items: center;
        justify-content: center;
    }

    .coupon-card__action-button {
        position: relative;
        display: flex;
        width: 30px;
        height: 60px;
        align-items: center;
        justify-content: space-evenly;
        flex-direction: column;
        padding: 0;
        border: 0;
        border-radius: 6px;
        box-sizing: border-box;
        color: #FFFFFF;
        cursor: pointer;
        font-family: inherit;
        appearance: none;
        transition: filter 0.2s ease, opacity 0.2s ease;

        &::before {
            position: absolute;
            inset: 0 -7px;
            content: "";
        }

        >span {
            font-size: 14px;
            line-height: 14px;
        }

        &:hover:not(:disabled) {
            filter: brightness(0.94);
        }

        &:focus-visible {
            outline: 2px solid rgba(48, 49, 51, 0.85);
            outline-offset: 2px;
        }

        &:disabled {
            opacity: 0.55;
            cursor: not-allowed;
        }
    }

    .coupon-card__validity {
        flex: 0 0 18px;
        width: 100%;
        overflow: hidden;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    @media (prefers-reduced-motion: reduce) {
        .coupon-card__action-button {
            transition: none;
        }
    }
}
</style>
